@switch (columnName) {
  @case ('power') {
    {{ form.power.value + ' ' }}
    {{ powerUnit[form.powerType.value] ? powerUnit[form.powerType.value] : '' }}
  }
  @case ('edit') {
    @if (!hideButtons) {
      <app-ui-button
        buttonType="icon-button"
        icon="edit"
        [ariaLabel]="'edit' | translate"
        (click)="buttonFunctions.edit()"
      ></app-ui-button>
    }
  }
  @case ('delete') {
    @if (!hideButtons) {
      <app-ui-button
        buttonType="icon-button"
        icon="delete"
        [ariaLabel]="'delete' | translate"
        (click)="buttonFunctions.delete()"
      ></app-ui-button>
    }
  }
  @default {
    {{ form.get(columnName)?.value }}
  }
}
